import React, { useState, useRef, useEffect } from "react";
import { FaWhatsapp } from 'react-icons/fa';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";

export default function Sidebar() {

  const [openMenus, setOpenMenus] = useState({ master: false,tentang: false,beranda: false });
  
  const toggleMenu = (menuName) => {
    setOpenMenus((prev) => ({ ...prev, [menuName]: !prev[menuName] }));
  };
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();            

  const pageTitles = {
    "/": "Form Ajuan",
    "/admin/": "Halaman Admin",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
    "/updateRf/": "Update Ajuan",
  };

  const isActive = (path) => {
    return location.pathname === path;
  };
   
  return (
    <>     
      <aside
      className={`bg-gray-800 text-white w-64 flex-col absolute md:relative md:flex rounded-3xl ${
        sidebarOpen ? "flex" : "hidden"
      }`}
      >
        <nav className="flex-1 p-4 space-y-2">
          <button
            onClick={() => toggleMenu("beranda")}
            className="w-full text-left py-2 px-4 rounded hover:bg-gray-700 flex justify-between items-center"
          >
            Halaman Beranda
            <span>{openMenus.beranda ? "▾" : "▸"}</span>
          </button>
            {openMenus.beranda && (
              <ul className="pl-6 mt-1 space-y-1 text-sm text-gray-300">
                <li>
                  <Link to="/admin" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Banner
                  </Link>
                </li>
                <li>
                  <Link to="/admin/whyus" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/whyus") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Kenapa Memilih 
                  </Link>
                </li>
                <li>
                  <Link to="/admin/provider" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/provider") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Provider 
                  </Link>
                </li>
                <li>
                  <Link to="/admin/product" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/product") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Product  
                  </Link>
                </li>
                <li>
                  <Link to="/admin/statistic" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/statistic") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Statistik
                  </Link>
                </li>
                <li>
                  <Link to="/admin/testimoni" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/testimoni") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Testimoni
                  </Link>
                </li>
              </ul>
            )}
          <button
            onClick={() => toggleMenu("tentang")}
            className="w-full text-left py-2 px-4 rounded hover:bg-gray-700 flex justify-between items-center"
          >
            Halaman Tentang Kami
            <span>{openMenus.tentang ? "▾" : "▸"}</span>
          </button>
            {openMenus.tentang && (
              <ul className="pl-6 mt-1 space-y-1 text-sm text-gray-300">
                <li>
                  <Link to="/admin/about" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/about") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Tentang Kami
                  </Link>
                </li>
                <li>
                  <Link to="/admin/gallery" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/gallery") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Galeri
                  </Link>
                </li>
                <li>
                  <Link to="/admin/team" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/team") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Section Tim 
                  </Link>
                </li>
              </ul>
            )}
          <button
            onClick={() => toggleMenu("master")}
            className="w-full text-left py-2 px-4 rounded hover:bg-gray-700 flex justify-between items-center"
          >
            Panduan
            <span>{openMenus.master ? "▾" : "▸"}</span>
          </button>
            {openMenus.master && (
              <ul className="pl-6 mt-1 space-y-1 text-sm text-gray-300">
                <li>
                  <Link to="/admin/media" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/media") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Download Media
                  </Link>
                </li>
                <li>
                  <Link to="/admin/panduan-aplikasi" className={`block py-1 px-2 rounded hover:bg-gray-700 ${isActive("/admin/panduan-aplikasi") ? "bg-gray-900 font-semibold" : ""
              }`} onClick={() => setSidebarOpen(false)}>
                    Panduan Aplikasi
                  </Link>
                </li>
              </ul>
            )}
          <Link
            to="/admin/article" className={`block py-2 px-4 rounded hover:bg-gray-700 ${isActive("/admin/article") ? "bg-gray-900 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
          >
            Artikel
          </Link>   
          <Link
            to="/admin/live" className={`block py-2 px-4 rounded hover:bg-gray-700 ${isActive("/admin/live") ? "bg-gray-900 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
          >
            LIVE
          </Link>      
          <Link
            to="/admin/running" className={`block py-2 px-4 rounded hover:bg-gray-700 ${isActive("/admin/running") ? "bg-gray-900 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
          >
            Running Text
          </Link>       
          <Link
            to="/admin/sectionhero" className={`block py-2 px-4 rounded hover:bg-gray-700 ${isActive("/admin/sectionhero") ? "bg-gray-900 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
          >
            Section Hero
          </Link>      
          <Link
            to="/admin/contactdata" className={`block py-2 px-4 rounded hover:bg-gray-700 ${isActive("/admin/contactdata") ? "bg-gray-900 font-semibold" : ""
              }`}
              onClick={() => setSidebarOpen(false)}
          >
            Contact Data
          </Link>    
        </nav>
      </aside>
    </>
  )    
}